import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class CompanyAdministrativeService {
  private URL = environment.api + "api/companyAdministrative";

  constructor(
    private http: HttpClient
  ) { }

  getAllCompaniesAdministrative() {
    return this.http.get(this.URL + "/all");
  }

  getRelatedCompaniesByCompany(companyId) {
    return this.http.get(this.URL + "/relations/" + companyId);
  }

  getRelatedCompaniesDataByCompany(companyId) {
    return this.http.get(this.URL + "/relations-with-names/" + companyId);
  }

  associateCompanies(companyAdminId,companyFiscalId) {
    return this.http.post(this.URL + "/relation" + "/" + companyAdminId + "/" + companyFiscalId,null);
  }

  removeAssociation(companyAdminId,companyFiscalId) {
    return this.http.delete(this.URL + "/relation/" + companyAdminId + "/" + companyFiscalId);
  }
}
